var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 8C2.75 5.10051 5.10051 2.75 8 2.75C8.83951 2.75 9.63098 2.94649 10.3329 3.29532C10.7038 3.47965 11.154 3.32839 11.3383 2.95745C11.5226 2.58652 11.3714 2.13638 11.0004 1.95204C10.0957 1.50245 9.07628 1.25 8 1.25C4.27208 1.25 1.25 4.27208 1.25 8C1.25 11.7279 4.27208 14.75 8 14.75C11.7279 14.75 14.75 11.7279 14.75 8C14.75 7.74708 14.7361 7.49713 14.7088 7.25093C14.6633 6.83922 14.2927 6.54236 13.881 6.58787C13.4693 6.63339 13.1724 7.00403 13.2179 7.41574C13.2391 7.60732 13.25 7.80224 13.25 8C13.25 10.8995 10.8995 13.25 8 13.25C5.10051 13.25 2.75 10.8995 2.75 8ZM14.5303 3.86366C14.8232 3.57077 14.8232 3.0959 14.5303 2.803C14.2374 2.51011 13.7626 2.51011 13.4697 2.803L8 8.27267L6.53033 6.803C6.23744 6.51011 5.76256 6.51011 5.46967 6.803C5.17678 7.0959 5.17678 7.57077 5.46967 7.86366L7.46967 9.86366C7.61032 10.0043 7.80109 10.0833 8 10.0833C8.19891 10.0833 8.38968 10.0043 8.53033 9.86366L14.5303 3.86366Z",
    fill: "#22282F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCircle);
export default __webpack_public_path__ + "static/media/checkboxCircle.ebefe1d585148602a563ecea3bf37817.svg";
export { ForwardRef as ReactComponent };